import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/browse-suppliers/page.tsx");
